import { render, staticRenderFns } from "./BaseEmailList.vue?vue&type=template&id=6c6c88f6&scoped=true"
import script from "./BaseEmailList.vue?vue&type=script&lang=js"
export * from "./BaseEmailList.vue?vue&type=script&lang=js"
import style0 from "./BaseEmailList.vue?vue&type=style&index=0&id=6c6c88f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c88f6",
  null
  
)

export default component.exports